import React, { useState } from 'react';
import { Paper, Box, Typography, Stack } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import { useNavigate, useParams } from 'react-router-dom';

import { getRuta } from '../../../helpers/Helpers';
import ClientDetails from './ClientDetails';
import ClientReferences from './ClientReferences';
import ClientCredits from './ClientCredits';
import SegmentedTabs from '../../../components/ui/SegmentedTabs';
import { monoFont } from '../../../theme';

const initials = (fullName) => {
	const parts = (fullName || '').trim().split(/\s+/);
	return `${(parts[0] || '')[0] || ''}${(parts[1] || '')[0] || ''}`.toUpperCase();
};

export const DetalleClientContainer = () => {
	let ruta = getRuta();
	let navigate = useNavigate();
	const { id } = useParams();
	const [value, setValue] = useState(0);
	const [clientName, setClientName] = useState('');
	const [promedio, setPromedio] = useState(0);

	return (
		<div>
			<Box
				onClick={() => navigate(`${ruta}/clients`)}
				sx={{
					display: 'inline-flex',
					alignItems: 'center',
					gap: '6px',
					color: 'text.disabled',
					fontSize: 13,
					fontWeight: 500,
					marginBottom: '16px',
					cursor: 'pointer',
					'&:hover': { color: '#00a152' }
				}}
			>
				<ArrowBackRoundedIcon sx={{ fontSize: 19 }} />
				Volver a clientes
			</Box>

			<Paper sx={{ padding: '22px 24px', marginBottom: '14px' }}>
				<Stack direction="row" spacing={2} alignItems="flex-start">
					<Box
						sx={{
							width: 52,
							height: 52,
							borderRadius: '12px',
							backgroundColor: 'success.light',
							color: 'success.main',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontSize: 18,
							fontWeight: 600,
							flexShrink: 0
						}}
					>
						{initials(clientName)}
					</Box>
					<Box sx={{ flex: 1, minWidth: 0 }}>
						<Typography sx={{ fontSize: 19, fontWeight: 700, letterSpacing: '-.3px' }}>{clientName}</Typography>
						<Typography sx={{ fontSize: 12.5, color: 'text.secondary', marginTop: '3px', fontFamily: monoFont }}>Cliente #{id}</Typography>
					</Box>
					<Box sx={{ textAlign: 'right', flexShrink: 0 }}>
						<Typography sx={{ fontSize: 11, color: 'text.secondary', fontWeight: 500 }}>Estadística global</Typography>
						<Typography sx={{ fontFamily: monoFont, fontSize: 18, fontWeight: 600, color: 'warning.main', marginTop: '2px' }}>{promedio}</Typography>
					</Box>
				</Stack>
			</Paper>

			<Box sx={{ marginBottom: '16px' }}>
				<SegmentedTabs
					value={value}
					onChange={setValue}
					tabs={[
						{ label: 'Cliente', icon: <PersonRoundedIcon sx={{ fontSize: 17 }} /> },
						{ label: 'Referencias', icon: <GroupsRoundedIcon sx={{ fontSize: 17 }} /> },
						{ label: 'Créditos', icon: <CreditCardRoundedIcon sx={{ fontSize: 17 }} /> }
					]}
				/>
			</Box>

			{value === 0 && <ClientDetails id={id} setClientName={setClientName} setPromedio={setPromedio} />}
			{value === 1 && <ClientReferences id={id} />}
			{value === 2 && <ClientCredits id={id} />}
		</div>
	);
};
